import { Box } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Editor from './Editor/Editor';
import Chip from '@mui/material/Chip';
import { updateTestCaseStepEditorData } from '@pages/testcases/store';

const TestcaseStepEditorField = ({ kind, step, zIndex, propToRerenderEditorJs, checkingMode }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const handleChangeFieldValue = (newValue) => {
        dispatch(updateTestCaseStepEditorData({ step, kind, newValue }));
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
                mb: 2,
            }}
        >
            <Chip
                sx={{ ml: checkingMode ? 0 : 8.5, alignSelf: 'flex-start', fontSize: '0.8125rem' }}
                size="small"
                label={t(kind === 'script' ? 'action' : 'expected_result')}
            />
            <Editor
                editorId={`${step.id}${kind}`}
                editorData={step[kind]}
                setEditorData={handleChangeFieldValue}
                zIndex={zIndex}
                placeholder={`${t('enter_step_description')}...`}
                propToRerender={propToRerenderEditorJs}
                readOnly={checkingMode}
            />
        </Box>
    );
};

export default TestcaseStepEditorField;
